const o = (o2, e, s = "some") => e[s]((e2) => e2[o2]);
export {
  o as getUseQueryHookState
};
//# sourceMappingURL=getUseQueryHookState.js.map
